import {action, observable} from 'mobx';

class PreloaderStore {

  @observable isActive = false;

  @action activate = () => {
    this.isActive = true;
  };

  @action disable = () => {
    this.isActive = false;
  };
}
export default new PreloaderStore();



// WEBPACK FOOTER //
// ./src/stores/PreloaderStore.js